import React, { useState, useEffect } from "react";
import Select from 'react-select';
import axios from 'axios';
import { dataUser } from "../Helpers/util";

import $ from 'jquery';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { TickList } from "../../Redux/action/tickList";

import axiosInstance from "../../utils/axiosInstance";
import SwSelect from "../Common/SwReactSelect/SwReactSelect";
import SwInput from "../Common/FormComponent/SwInput";
import SwTextArea from "../Common/FormComponent/SwTextArea";
import SwOffCanvas from "../Common/SwOffCanvas/SwOffCanvas";
import SwButton from "../Common/SwButtons/SwButtons";
import AntDUpload from "../Common/AntDUpload/AntDUpload";
const userDataLocal = dataUser();
const UserObj = JSON.parse(userDataLocal);

function RaiseSnag(props) {

    const [btnStatus, setButtonStatus] = useState(false);
    const [locations, setLocations] = useState([]);
    const [locationIds, setLocationIds] = useState([]);
    const [projectError, setProjectError] = useState('')
    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [locationId, setLocationId] = useState('');
    const [ticketType, setTicketType] = useState(''); // Set the default ticket type
    const [category, setCategory] = useState([]);
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [subCategory, setSubCategory] = useState(null);
    const [text, setText] = useState('');
    const [descriptionText, setDescriptionText] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState('');
    const [imageSrc, setImageSrc] = useState('');
    const [value, setValue] = useState('');
    const [files, setFiles] = useState([]);
    const [locationError, setLocationError] = useState('')
    const [floorError, setFloorError] = useState('')
    const [categoryError, setCategoryError] = useState('')
    const [textError, setTextError] = useState('')
    const [subCategoryError, setSubCategoryError] = useState('')
    const [fileId, setFileId] = useState('')


    useEffect(() => {
        const authToken = JSON.parse(localStorage.getItem('headData'))?.spintlyToken;


        axios
            .get(`${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`, {
                params: { spoc: UserObj.rec_id, client: UserObj.company_id },
                headers: {
                    Authorization: authToken,
                }
            })
            .then(res => {
                if (res.data.status === 'success') {
                    setLocations(res.data.data);

                    // Extract rec_ids from locations
                    const ids = res.data.data.map(location => location.rec_id);
                    setLocationIds(ids); // Store rec_ids for use in getProjects
                }
            })
            .catch(err => {
                console.log('Error fetching locations:', err);
            });
    }, []);

    // Fetch projects
    useEffect(() => {
        // Define an async function to fetch projects
        const fetchProjects = async () => {
            const getCompanyId = UserObj ? UserObj.company_id : null;


            // Check if necessary data exists before making the API call


            try {
                // Perform the API request with async/await
                const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/getProjects/${getCompanyId}`, {
                    locationIds: locationIds,
                    status: 'Accepting snags'  // Pass the array of location IDs
                },);

                // Check the response and update the state
                if (response.status === 200 && response.data.statusText === "SUCCESS") {
                    setProjects(response.data.data);
                }
            } catch (error) {
                // console.error('Error fetching projects:', error);
                // toast.error('Failed to fetch projects!', {
                //     
                // });
            }
        };

        // Call the fetchProjects function
        fetchProjects();

    }, [UserObj, locationIds]);


    useEffect(() => {
        // Automatically select project if there's only one in the array
        if (projects.length === 1) {
            const project = projects[0];
            setSelectedProject(project);
            setLocationId(project.location.locationId); // Set location ID dynamically
            setTicketType(project.ticketType); // Adjust as needed
        }
    }, [projects]);




    const handleProjectChange = async (selectedOption) => {

        const project = projects.find(item => item.projectId === selectedOption.value);
        setSelectedProject(project);
        setLocationId(project.location.locationId); // Set location ID dynamically
        setTicketType(project.ticketType); // Adjust as needed
        setProjectError('')
        // Call the categoryData function after setting locationId
        await categoryData(project.location.locationId, project.ticketType);
    };



    const handleText = (e) => {
        setText(e.target.value)
        if (e.target.value.trim()) {
            setTextError('');
        }
    }

    const handleDescription = (e) => {
        setDescriptionText(e.target.value)

    }

    const handleCategoryChange = async (selectedOption) => {

        setSelectedCategory(selectedOption);
        await categorySubData(locationId, selectedOption);
        if (!selectedOption) {
            setCategoryError("Issue Related to can't be empty");
        } else {
            setCategoryError('');
        }
        setSubCategory('');
    };

    const handleSubCategoryChange = (selectedOption) => {
        setSubCategory(selectedOption)
        if (!selectedOption) {
            setSubCategoryError("Issue Related to can't be empty");
        } else {
            setSubCategoryError('');
        }
    };


    const categoryData = async (locationId, ticketType) => {
        try {

            const data = {
                location: locationId,
                company_id: UserObj ? UserObj.company_id : null,
                ticketType: ticketType // Include ticket type
            };


            const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/getCat`, data);
            const formattedCategories = response.data.data.map(item => ({
                value: item, // Each category as its value
                label: item, // Display the same value as label
            }));
            setCategory(formattedCategories); // Update state with formatted categories
        } catch (error) {
            console.error(error);
        }
    };



    const categorySubData = async (locationId, selectedCategory) => {
        try {

            const data = {
                location: locationId,
                company_id: UserObj ? UserObj.company_id : null,
                category: selectedCategory.value
            };


            const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/getSubCat`, data);
            setSubCategoryData(response.data.data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleRaiseSnag = async (e) => {
        e.preventDefault();
        setLocationError('');
        setFloorError('');
        setCategoryError('');
        setTextError('');
        setSubCategoryError('');
        let isValid = true;

        if (!selectedProject) {
            setProjectError("Project Name cannot be empty");
            isValid = false;
        }

        if (!selectedCategory) {
            setCategoryError("Issue Category can't be empty");
            isValid = false;
        }

        if (!subCategory) {
            setSubCategoryError("Issue sub-category can't be empty");
            isValid = false;
        }

        if (!text.trim()) {
            setTextError("Please state the issue");
            isValid = false;
        }

        if (isValid) {
            setButtonStatus(true);
            try {
                // Constructing requestData
                const requestData = {
                    locationCode: locationId,
                    category: selectedCategory ? selectedCategory.value : '',
                    subCategory: subCategory ? subCategory.value : '',
                    subject: text,
                    description: descriptionText,
                    userId: UserObj ? String(UserObj.rec_id) : '',
                    userName: UserObj ? `${UserObj.fname} ${UserObj.lname}` : '',
                    email: UserObj ? UserObj.email : '',
                    phone: UserObj ? UserObj.phone : '',
                    companyId: UserObj ? String(UserObj.company_id) : '',
                    companyName: UserObj ? UserObj.company_name : '',
                    floor: selectedProject.floor.floorName,
                    formInfo: {
                        projectId: selectedProject.projectId,
                        projectName: selectedProject.projectName,
                        projectCompanyName: selectedProject.projectCompanyName
                    },
                    ticketType: ticketType
                };

                // Make the API call to add the ticket
                const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/addTicket`, requestData);

                // Debugging line to check response structure

                if (response?.data?.statusValue === 200) {
                    const ticketId = response.data.data.id;
                    setButtonStatus(false);

                    // Handle file attachments
                    for (const fileObj of files) {
                        const formData = new FormData();
                        formData.append('file', fileObj.originFileObj);

                        await axiosInstance.post(
                            `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/add-attachments`,
                            formData,
                            { params: { ticketId } }
                        );
                    }

                    // Reset file input and other states
                    setFiles([]);
                    props.snagListApi();
                    document.querySelector('input[type="file"]').value = '';


                    setTimeout(() => {
                        toast.success('Request is submitted successfully', {

                        });
                    }, 1000);

                    // Close modal
                    props?.onClose();
                    resetValue();
                    // $('.close').click();  // Temporarily comment out for debugging

                } else {
                    toast.error("Error adding ticket. Please try again later", {

                    });
                }
            } catch (error) {
                console.error("Error:", error);
                toast.error("Error adding ticket. Please try again later", {

                });
            }
        }

        // Reset form fields
        setSubCategory(null);
        setText('');
        setDescriptionText('');
    };

    const resetValue = () => {
        setSelectedCategory('');
        setSelectedProject('')
        setProjectError('')
        setSubCategory('')
        setLocationError('');
        setText('')
        setDescriptionText('')
        setFloorError('');
        setCategoryError('');
        setTextError('');
        setSubCategoryError('');
        setFiles([]);
        document.querySelector('input[type="file"]').value = '';
        // setAttachmentError('');

    }


    return (
        <>
            <SwOffCanvas
                show={props?.show}
                onHide={() => {
                    props?.onClose();
                    resetValue();
                }}
                title="Raise a snag"
                footer={
                    <>
                        <div className="OffCanvasFooter_Btns">
                            <SwButton
                                size="md"
                                variant="dark-outline"
                                onClick={resetValue}
                            >
                                Reset
                            </SwButton>


                            {btnStatus == false ? <SwButton
                                size="md"
                                onClick={handleRaiseSnag}
                            >
                                Submit
                            </SwButton> :
                                <SwButton loading disabled > Processing </SwButton>}
                        </div>
                    </>
                }
            >
                <div>
                    <div className="SwFormGroup">
                        <form>
                            <div className="row">
                                {/* Location Name */}
                                <div className="col-md-12 ">
                                    <div className="SwFormGroup">
                                        <label className="SwFormLabel">Project Name<span className="Required">*</span></label>
                                        <SwSelect
                                            value={selectedProject ? { value: selectedProject.projectId, label: selectedProject.projectName } : null}
                                            onChange={handleProjectChange}
                                            options={projects.map(item => ({
                                                value: item.projectId,
                                                label: item.projectName
                                            }))}
                                            placeholder="Select Project name"
                                            isClearable={false}
                                        />
                                        <span className="SwTextDanger SwTextSmall">
                                            {projectError}
                                        </span>
                                    </div>
                                </div>


                                <div className="col-md-12 ">
                                    <div className="SwFormGroup">
                                        <label className="SwFormLabel">Company Name<span className="Required">*</span></label>
                                        <SwSelect
                                            value={selectedProject ? { value: selectedProject.projectCompanyName, label: selectedProject.projectCompanyName } : null}
                                            isDisabled={true}
                                            placeholder="Select Company name"
                                            isClearable={false}
                                        />
                                        <span className="SwTextDanger SwTextSmall">
                                            {locationError}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-12 ">
                                    <div className="SwFormGroup">
                                        <label className="SwFormLabel">Location Name<span className="Required">*</span></label>
                                        <SwSelect
                                            value={selectedProject ? { value: selectedProject.location.locationId, label: selectedProject.location.locationName } : null}
                                            isDisabled={true}
                                            placeholder="Select Location name"
                                            isClearable={false}
                                        />
                                        <span className="SwTextDanger SwTextSmall">
                                            {locationError}
                                        </span>
                                    </div>
                                </div>
                                {/* Floor Name */}
                                <div className="col-md-12 ">
                                    <div className="SwFormGroup">
                                        <label className="SwFormLabel">Floor Name<span className="Required">*</span></label>
                                        <SwSelect
                                            value={selectedProject ? { value: selectedProject.floor.floorId, label: selectedProject.floor.floorName } : null}
                                            isDisabled={true}
                                            placeholder="Select Floor name"
                                            isClearable={false}
                                        />
                                        <span className="SwTextDanger SwTextSmall">
                                            {floorError}
                                        </span>
                                    </div>
                                </div>

                                {/* Issue sub-category */}
                                <div className="col-md-12 ">
                                    <div className="SwFormGroup">
                                        <label className="SwFormLabel">Category<span className="Required">*</span></label>
                                        <SwSelect
                                            value={selectedCategory}
                                            onChange={handleCategoryChange}
                                            options={category}
                                            placeholder="Select Category"
                                            isClearable={false}
                                        />
                                        <span className="SwTextDanger SwTextSmall">
                                            {categoryError}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-12 ">
                                    <div className="SwFormGroup">
                                        <label className="SwFormLabel">Sub-category<span className="Required">*</span></label>
                                        <SwSelect
                                            value={subCategory}
                                            onChange={handleSubCategoryChange}
                                            options={subCategoryData.map(item => ({
                                                value: item,
                                                label: item
                                            }))}
                                            placeholder="Select Sub-category"
                                            isClearable={false}
                                        />
                                        <span className="SwTextDanger SwTextSmall">
                                            {subCategoryError}
                                        </span>
                                    </div>
                                </div>
                                {/* Please state the issue */}
                                <div className="col-md-12 col-xl-12 col-lg-12 mt-3">
                                    <div className="SwFormGroup">
                                        <label className="SwFormLabel">Subject<span className="Required">*</span></label>
                                        <SwInput
                                            value={text}
                                            type="text"
                                            onChange={handleText}
                                            placeholder="Enter Subject"
                                            isClearable={false}
                                        />
                                        <span className="SwTextDanger SwTextSmall">
                                            {textError}
                                        </span>
                                    </div>
                                </div>
                                {/* Description */}
                                <div className="col-md-12 col-xl-12 col-lg-12 mt-3">
                                    <div className="SwFormGroup">
                                        <label className="SwFormLabel">Description</label>
                                        <SwTextArea
                                            value={descriptionText}
                                            onChange={handleDescription}
                                            rows="4"
                                            placeholder="Enter Description"
                                        />
                                    </div>
                                </div>
                                {/* Attachment */}
                                <div className="row mb-4">
                                    <div className="col-md-8">
                                        <AntDUpload
                                            type="button"
                                            listType="text"
                                            multiple
                                            autoUpload={false}
                                            fileList={files}
                                            onChange={({ fileList }) => {
                                                setFiles(fileList);
                                            }}
                                        >
                                            <SwButton variant="primary" icon={<i className='bi bi-upload'></i>}>Upload Documents</SwButton>
                                        </AntDUpload>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </SwOffCanvas>
        </>
    );
}

export default RaiseSnag;
